/**
 * Chọn variant tại chỗ cho PDP ở chế độ variant (Material + Carat là option thật).
 *
 * Mô hình cũ của theme: mỗi tổ hợp là một sản phẩm riêng, nút bấm điều hướng sang URL khác.
 * Mô hình mới: một shape là một sản phẩm nhiều variant, nên nút bấm phải đổi variant tại chỗ —
 * cập nhật id gửi lên giỏ, giá, ảnh và URL mà không tải lại trang.
 *
 * Chỉ chạy khi trang có #pdp-variant-data, nên sản phẩm cũ (nhẫn cưới) không bị ảnh hưởng.
 */
(function () {
  'use strict';

  // Snippet chứa script này được render 2 lần trên một số template, nên chặn bind trùng listener.
  if (window.__pdpVariantOptionsReady) return;
  window.__pdpVariantOptionsReady = true;

  var dataEl = document.getElementById('pdp-variant-data');
  if (!dataEl) return;

  var data;
  try {
    data = JSON.parse(dataEl.textContent);
  } catch (e) {
    console.error('[pdp-variant-options] Không đọc được dữ liệu variant', e);
    return;
  }

  var optionNames = data.option_names || [];
  var variants = data.variants || [];
  if (!variants.length) return;

  var materialIndex = optionNames.indexOf('Material');
  var caratIndex = optionNames.indexOf('Carat');
  if (materialIndex === -1 || caratIndex === -1) return;

  function findById(id) {
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].id === id) return variants[i];
    }
    return null;
  }

  function findVariant(material, carat) {
    for (var i = 0; i < variants.length; i++) {
      var o = variants[i].options;
      if (o[materialIndex] === material && o[caratIndex] === carat) return variants[i];
    }
    return null;
  }

  // Trạng thái ban đầu lấy từ variant form đang gửi đi, để khớp với những gì server đã render
  var idInput = document.querySelector('input.product-variant-id');
  var initial = idInput ? findById(parseInt(idInput.value, 10)) : null;
  if (!initial) initial = variants[0];

  var selection = {
    Material: initial.options[materialIndex],
    Carat: initial.options[caratIndex],
  };

  /**
   * Không phải tổ hợp nào cũng tồn tại — catalog thưa, chỉ vài shape có mức 1.5 carat. Khi đổi
   * một chiều mà tổ hợp không có, giữ nguyên chiều vừa chọn và lùi chiều còn lại về giá trị
   * hợp lệ đầu tiên, thay vì để khách kẹt ở tổ hợp trống.
   */
  function resolve(optionName, value) {
    var material = optionName === 'Material' ? value : selection.Material;
    var carat = optionName === 'Carat' ? value : selection.Carat;

    var variant = findVariant(material, carat);
    if (variant) return variant;

    for (var i = 0; i < variants.length; i++) {
      var o = variants[i].options;
      if (optionName === 'Material' && o[materialIndex] === value) return variants[i];
      if (optionName === 'Carat' && o[caratIndex] === value) return variants[i];
    }
    return null;
  }

  function updateActiveStates() {
    document.querySelectorAll('a.variant-option-link').forEach(function (link) {
      var name = link.getAttribute('data-option-name');
      var value = link.getAttribute('data-option-value');
      var item = link.closest('.cli-item');
      if (!item) return;

      var isActive = selection[name] === value;
      item.classList.toggle('active', isActive);

      // Đánh dấu tổ hợp không tồn tại để khách thấy trước khi bấm
      var material = name === 'Material' ? value : selection.Material;
      var carat = name === 'Carat' ? value : selection.Carat;
      item.classList.toggle('unavailable-combo', !findVariant(material, carat));

      if (isActive) {
        var group = item.closest('.cstm-line-itemoption');
        var span = group ? group.querySelector('.selected-value') : null;
        if (span) span.textContent = value;
      }
    });
  }

  /**
   * Title mang carat đang chọn ("The Ashley Set With A 1 Carat Princess Moissanite") vì ở mô hình
   * cũ mỗi carat là một sản phẩm riêng nên carat vốn nằm trong tên.
   */
  function updateTitle(variant) {
    var el = document.querySelector('.product-title[data-title-template]');
    if (!el) return;

    var template = el.getAttribute('data-title-template');
    el.textContent = template.replace('{carat}', variant.options[caratIndex]);
  }

  // Giá nằm ở price.prd-price (block 'price'); template stone dùng .stone-prices price
  var PRICE_SELECTORS = ['price.prd-price', '.stone-prices price', '.prd-price'];

  function updatePrice(variant) {
    if (!variant.price) return;

    // Khối .pdp-price hiện giá sau giảm (display_price) + giá gốc gạch ngang; các chỗ khác giá thật
    var onSale = variant.discount_percent > 0;
    var shown = onSale && variant.display_price ? variant.display_price : variant.price;

    for (var i = 0; i < PRICE_SELECTORS.length; i++) {
      var el = document.querySelector(PRICE_SELECTORS[i]);
      if (el) {
        el.innerHTML = shown;
        break;
      }
    }

    updateComparePrice(variant, onSale);
    updateTotalPrice(variant);
  }

  /**
   * Giá gốc gạch ngang + badge % trong .pdp-price (snippet pdp-title). Variant không sale thì bỏ
   * class on-sale để CSS ẩn hai phần này đi.
   */
  function updateComparePrice(variant, onSale) {
    var wrap = document.querySelector('.pdp-price');
    if (!wrap) return;

    wrap.classList.toggle('pdp-price--on-sale', onSale);
    if (!onSale) return;

    var compare = wrap.querySelector('.prd-compare-price');
    var badge = wrap.querySelector('.prd-sale-badge');
    if (compare) compare.textContent = variant.original_price;
    if (badge) badge.textContent = '-' + variant.discount_percent + '%';
  }

  /**
   * Khối "Total Price" và giá trên nút mua tự tính lại mỗi giây từ dataset.basePrice cộng thêm
   * addon đã chọn. Chỉ cần đổi basePrice là nó tự đúng — không chép lại phần cộng addon ở đây.
   * Ghi thẳng text luôn để khỏi phải chờ hết một nhịp interval.
   */
  function updateTotalPrice(variant) {
    var total = document.getElementById('totalPriceDisplay');
    if (!total) return;

    if (variant.price_raw != null) total.dataset.basePrice = variant.price_raw;

    // Sale checkout: hiện display_price, gạch original_price (giá thật không đổi)
    var onSale = variant.discount_percent > 0 && variant.display_price;
    var shown = onSale ? variant.display_price : variant.price;
    total.textContent = shown;

    var original = document.querySelector('.total-price-original');
    if (original) {
      original.hidden = !onSale;
      if (onSale) original.textContent = variant.original_price;
    }

    var button = document.getElementById('button-price');
    if (button) button.textContent = shown;
  }

  /**
   * Gallery là slider jQuery đánh index và không gắn media id vào DOM, nên dò slide theo tên
   * file ảnh của variant rồi bấm vào đúng slide đó — để slider tự lo phần chuyển ảnh chính.
   *
   * Ảnh gộp theo màu kim loại (14k và 18k cùng màu dùng chung file) nên đổi carat không đổi ảnh.
   */
  var SLIDE_SELECTORS = ['.cstm-image-slide', '.mobile-img-thumb-slide'];

  function colorOf(material) {
    if (material.indexOf('Yellow') > -1) return 'yg';
    if (material.indexOf('Rose') > -1) return 'rg';
    return 'wg';
  }

  // Ảnh dùng chung giữa các karat cùng màu, nên mỗi màu chỉ có một file đại diện
  var imageFileByColor = (function () {
    var map = {};
    variants.forEach(function (v) {
      var color = colorOf(v.options[materialIndex]);
      if (v.image_file && !map[color]) map[color] = v.image_file;
    });
    return map;
  })();

  /**
   * Chỉ hiện thumbnail của màu đang chọn. Ẩn theo nguyên tắc loại trừ — một slide chỉ bị ẩn khi
   * nó mang ảnh của MỘT MÀU KHÁC. Slide không nhận diện được (ảnh CAD, video từ medialist) luôn
   * được giữ lại, để việc bổ sung media sau này không bị ẩn nhầm.
   */
  function filterGalleryByColor(variant) {
    var currentColor = colorOf(variant.options[materialIndex]);

    var otherFiles = [];
    Object.keys(imageFileByColor).forEach(function (color) {
      if (color !== currentColor) otherFiles.push(imageFileByColor[color]);
    });

    SLIDE_SELECTORS.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (slide) {
        // Dùng class chứ không set style.display: theme khai báo display:block !important
        // cho .cstm-image-slide nên inline style bị thua và slide vẫn chiếm chỗ.
        var hide;

        // Media từ metaobject mang sẵn màu — dùng thẳng, chính xác hơn dò tên file
        var material = slide.getAttribute('data-material');
        if (material) {
          hide = material !== currentColor;
        } else {
          // Ảnh gốc của sản phẩm không có thuộc tính này, đối chiếu theo file của màu khác
          var img = slide.querySelector('img');
          var src = img ? img.getAttribute('src') || '' : '';

          hide = otherFiles.some(function (file) {
            return file && src.indexOf(file) > -1;
          });
        }

        slide.classList.toggle('material-hidden', hide);
      });
    });
  }

  function updateGallery(variant) {
    if (!variant.image_file) return;

    SLIDE_SELECTORS.forEach(function (selector) {
      var slides = document.querySelectorAll(selector);
      for (var i = 0; i < slides.length; i++) {
        var img = slides[i].querySelector('img');
        var src = img ? img.getAttribute('src') || '' : '';
        if (src.indexOf(variant.image_file) > -1) {
          if (!slides[i].classList.contains('active')) slides[i].click();
          break;
        }
      }
    });

    filterGalleryByColor(variant);
  }

  function updateFormAndUrl(variant) {
    if (idInput) {
      idInput.value = variant.id;
      idInput.disabled = !variant.available;
    }

    var url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url.toString());
  }

  var currentVariant = initial;

  function select(optionName, value) {
    var variant = resolve(optionName, value);
    if (!variant) return;

    currentVariant = variant;

    selection.Material = variant.options[materialIndex];
    selection.Carat = variant.options[caratIndex];

    updateActiveStates();
    updateTitle(variant);
    updatePrice(variant);
    updateGallery(variant);
    updateFormAndUrl(variant);

    document.dispatchEvent(new CustomEvent('pdp:variant-changed', { detail: variant }));
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('a.variant-option-link');
    if (!link) return;

    event.preventDefault();
    event.stopPropagation();
    select(link.getAttribute('data-option-name'), link.getAttribute('data-option-value'));
  });

  updateActiveStates();

  /**
   * Gallery do jQuery dựng sau khi script này chạy, và slider còn dựng lại DOM nhiều lần trong
   * lúc khởi tạo — mỗi lần như vậy display:none bị xoá và cả 3 màu hiện lại. Nên vừa đợi slide
   * xuất hiện để đồng bộ lần đầu, vừa theo dõi thay đổi để áp lại bộ lọc.
   */
  function mainImageMatches(variant) {
    var main = document.querySelector('img.cstm-main-desktop-img, img.mobile-main-img');
    if (!main || !variant.image_file) return true;
    return (main.getAttribute('src') || '').indexOf(variant.image_file) > -1;
  }

  /**
   * Media của sản phẩm xếp theo thứ tự upload nên slider luôn mở ảnh đầu tiên, không phải ảnh
   * của variant đang chọn. Bấm đổi ảnh chỉ ăn sau khi slider gắn xong handler, nên phải thử lại
   * cho tới khi ảnh chính khớp.
   */
  function syncGalleryWhenReady(attempt) {
    if (!document.querySelector('.cstm-image-slide, .mobile-img-thumb-slide')) {
      if (attempt < 40) setTimeout(function () { syncGalleryWhenReady(attempt + 1); }, 150);
      return;
    }

    updateGallery(currentVariant);

    if (!mainImageMatches(currentVariant) && attempt < 40) {
      setTimeout(function () { syncGalleryWhenReady(attempt + 1); }, 150);
      return;
    }

    observeGallery();
  }

  function observeGallery() {
    if (typeof MutationObserver === 'undefined') return;

    var pending = false;
    var observer = new MutationObserver(function () {
      if (pending) return;
      pending = true;

      // Gộp nhiều lần dựng lại liên tiếp thành một lần áp bộ lọc
      setTimeout(function () {
        pending = false;
        filterGalleryByColor(currentVariant);
      }, 60);
    });

    document.querySelectorAll('.cstm-image-slider-wrapper, .mobile-img-thumb-wrapper').forEach(function (el) {
      observer.observe(el, { childList: true, subtree: true });
    });
  }

  syncGalleryWhenReady(0);
})();
